module.exports = __webpack_public_path__ + "img/lg_ring_g_0_0_null@2x.ba128814.png";